import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import { ColorsPalette } from '../../../../config/colors'

const QuestionBubble = ({ title, color = ColorsPalette.FIRST, style = {} }) => {
  return (
    <Tooltip title={title}>
      <FontAwesomeIcon icon={faQuestionCircle} color={color} style={style} />
    </Tooltip>
  )
}

export default QuestionBubble
